export default __webpack_public_path__ + "static/media/SndLowerPAroundBump.2804b6d3.mp3";